const truthy = new Set(['true', '1', 'yes', 'on']);
const falsy = new Set(['false', '0', 'no', 'off']);

export const readBooleanFlag = (value, fallback = false) => {
  if (value === undefined || value === null || value === '') {
    return fallback;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  const normalized = String(value).trim().toLowerCase();
  if (truthy.has(normalized)) return true;
  if (falsy.has(normalized)) return false;
  return fallback;
};

export const featureFlags = {
  realtimeScanUpdates: readBooleanFlag(
    process.env.REACT_APP_ENABLE_REALTIME_SCAN_UPDATES,
    true
  ),
  useBffSocket: readBooleanFlag(
    process.env.REACT_APP_USE_BFF_SOCKET,
    true
  ),
  progressiveDisclosure: readBooleanFlag(
    process.env.REACT_APP_ENABLE_PROGRESSIVE_DISCLOSURE,
    true
  ),
};

